// Four-tile summary at the top of every Planner view: Active Rocks,
// Open To-dos, Overdue, Opportunities. Numbers tint red when > 0 on
// the overdue tile so it reads as a warning.
import { tpApi } from "../api";
import { useResource } from "../hooks";
import { usePlannerRefreshKey } from "../sheets/PlannerCreateContext";

function Tile({
  label,
  value,
  tone,
  loading,
}: {
  label: string;
  value: number;
  tone: "blue" | "green" | "red" | "orange";
  loading: boolean;
}) {
  const dim = tone === "red" && value === 0;
  return (
    <div className="tp-stat-tile">
      <div className="tp-stat-label">{label}</div>
      <div className={`tp-stat-value tone-${dim ? "muted" : tone}`}>
        {loading ? "—" : value}
      </div>
    </div>
  );
}

export function StatsStrip() {
  const refreshKey = usePlannerRefreshKey();
  const stats = useResource(() => tpApi.stats(), [refreshKey]);
  const v = stats.data ?? { activeRocks: 0, openTodos: 0, overdue: 0, opportunities: 0 };
  return (
    <section aria-label="Planner summary" className="tp-stats-strip">
      <Tile label="Active Rocks" value={v.activeRocks} tone="blue" loading={stats.loading} />
      <Tile label="Open To-dos" value={v.openTodos} tone="green" loading={stats.loading} />
      <Tile label="Overdue" value={v.overdue} tone="red" loading={stats.loading} />
      <Tile label="Opportunities" value={v.opportunities} tone="orange" loading={stats.loading} />
    </section>
  );
}
